import { useCallback } from 'react';
import { useAuth } from '@hooks/useAuth';
import { combineUserName } from '@helpers/combineUserName';
import UserAvatarLetters from '@helpers/userAvatarLetters';
import { commentAuthor } from '@helpers/commentAuthor';
import { useAssetViewerState } from '@hooks/useAssetViewerState';

export default function useUserPicture() {
  const { user } = useAuth();
  const { commentsList } = useAssetViewerState();

  const setMyPicture = useCallback(() => {
    if (!user) return { name: '', userId: '', email: '', picture: null };
    const { id, email } = user;
    const alt = UserAvatarLetters(combineUserName(user));
    return { name: alt, email, userId: id, picture: user.pictureUrl };
  }, [user]);

  const getUserPicture = useCallback(
    (commentId: string) => {
      const comment = commentsList.find((it) => it.id === commentId);
      if (!comment?.user && !comment?.imported?.author) {
        return { name: '', email: '', userId: '', picture: null };
      }
      // Also for comments imported from Figma by someone not a member.
      const author = commentAuthor(comment);
      return {
        name: UserAvatarLetters(author.name),
        // Picks the pin's color, like an email does
        email: author.colorKey,
        userId: author.id,
        picture: author.pictureUrl
      };
    },
    [commentsList]
  );

  return { setMyPicture, getUserPicture };
}
